const state = {
}

const indexStore = {
  namespaced: true,
  state
}

export type IndexState = typeof state

export {
  indexStore
}
